export default __webpack_public_path__ + "static/media/logoE4Nutri.64634209.png";